<template>
    <div>
        <div class="content-wrapper" style="padding-bottom: 0">
            <h4 v-html="separateUrlTeams"></h4>
            <div><b>{{ $t('league') }}: </b>{{ data.competition }}</div>
            <div><b>{{ $t('date') }}: </b>{{ data.open_date }}</div>
            <div><b>{{ $t('event_id') }}: </b>{{ data.id }}</div>
        </div>
        <betfair-odds-datatable :game_id='data.id' :custom_filters="filters"></betfair-odds-datatable>
    </div>
</template>

<script>

import * as actions from "../../../../Config/ApiUrl";
import CoreLibrary from "../../../../../core/helpers/CoreLibrary";
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";

export default {
    name: "betfair-log-filter",
    mixins: [FormMixin],
    extends: CoreLibrary,
    props: ['sport', 'data', 'filters'],
    data() {
        return {
            separateUrlTeams: this.data.name,
            componentLoader: false,
            preloader: false,
            activeParams: {},
        }
    },
    created() {
        if (this.data) {
            this.separateUrlTeams = this.data.name;
        }
        let uri = window.location.href.split('?');
        if(uri.length === 2) {
            let vars = uri[1].split('&');
            let getVars = {};
            let tmp = '';
            vars.forEach(function (v) {
                tmp = v.split('=');
                if (tmp.length === 2)
                    getVars[tmp[0]] = tmp[1];
            });
            this.activeParams = getVars;
            console.log(getVars);
        }
    },
    methods: {
        applyFilter(item) {
            // check if the filter is already applied from the url using custom_filters

            // get url params
            let uri = window.location.href.split('?');
            let urlParams = {};
            if(uri.length === 2) {
                let vars = uri[1].split('&');
                let getVars = {};
                let tmp = '';
                vars.forEach(function (v) {
                    tmp = v.split('=');
                    if (tmp.length === 2)
                        getVars[tmp[0]] = tmp[1];
                });
                urlParams = getVars;
            }

            // check if the filter is already applied
            let customFilters = urlParams.custom_filters ? urlParams.custom_filters.split(',') : [];
            let filterIndex = customFilters.indexOf(item.id);
            if(filterIndex !== -1) {
                customFilters.splice(filterIndex, 1);
            } else {
                customFilters.push(item.id);
            }

            // update url
            let url = uri[0] + '?';
            if(customFilters.length > 0) {
                url += 'custom_filters=' + customFilters.join(',');
            }
            if(urlParams.per_page) {
                url += '&per_page=' + urlParams.per_page;
            }
            if(urlParams.page) {
                url += '&page=' + urlParams.page;
            }

            // redirect to the url
            window.location.href = url;
        }
    }
}
</script>